exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{width:100%;overflow:hidden;margin:0;padding:0;color:#fff;background-color:#242a35;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif}.App{max-width:920px;margin:0 auto;min-height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center}h1{color:#fff;padding:0 0 30px}.luckdraw{width:550px;height:350px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/App.styl
// module id = 88
// module chunks = 0